import { render } from "./delete_enfant.vue?vue&type=template&id=bf524cee&scoped=true"
import script from "./delete_enfant.vue?vue&type=script&lang=js"
export * from "./delete_enfant.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=bf524cee&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf524cee"]])

export default __exports__